type UnreadTotalPayload = {
  unreadCount?: number;
  totalUnreadCount?: number;
};

export function resolveUnreadTotal(payload: UnreadTotalPayload | null | undefined): number {
  if (!payload) return 0;

  const value =
    typeof payload.unreadCount === 'number'
      ? payload.unreadCount
      : typeof payload.totalUnreadCount === 'number'
        ? payload.totalUnreadCount
        : 0;

  return Number.isFinite(value) && value >= 0 ? value : 0;
}
